import React, { useState, useEffect } from 'react';
import { Button, Col, Row, ModalBody, Form, Spinner } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewGeodeticDatum, checkGeodeticDatumExists, updateGeodeticDatum } from '../../../../../slices/geodeticDatum/thunk';
import { setRequireCloseModal } from '../../../../../slices/geodeticDatum/reducer';
import OInput from '../../../../../Components/OElements/OInput';

const GeodeticDatumForm = ({
	dataGeodeticDatum,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const selectorGeodeticDatum = createSelector(
		state => state.GeodeticDatum,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal
	} = useSelector(selectorGeodeticDatum);

	// Validation
	const validation = useFormik({
		// Enable reinitialize when initial values need to be changed
		enableReinitialize: true,
		initialValues: {
			name: dataGeodeticDatum?.name || '',
			disable: dataGeodeticDatum?.disable || false,
		},
		validationSchema: Yup.object({
			name: Yup.string()
				.required('Campo requerido')
				.test('name-exists-check', 'Dato Geodésico ya existe', async function (value) {
					if (value && (!isEdit || value !== dataGeodeticDatum?.name)) {
						const result = await dispatch(checkGeodeticDatumExists(value));
						if (result.payload.exists) {
							return this.createError({ message: 'Dato Geodésico ya existe' });
						}
					}
					return true;
				}),
		}),
		validateOnChange: false,
		validateOnBlur: true,
		onSubmit: async values => {
			setIsLoading(true);
			const geodeticDatumData = {
				...values,
				...(isEdit && { _id: dataGeodeticDatum._id }),
			};

			if (isEdit) {
				await dispatch(updateGeodeticDatum(geodeticDatumData));
			} else {
				await dispatch(addNewGeodeticDatum(geodeticDatumData));
			}
			setIsLoading(false);
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
				if (toggleRefetch) {
					setTimeout(() => {
						toggleRefetch();
					}, 100);
				}
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (validation.isValid) setIsLoading(true);
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={12}>
						<OInput
							name='name'
							label='Nombre del Dato Geodésico'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={
							isLoading ||
							isAdding ||
							isUpdating
						}
					>
						{
							isLoading ||
								isAdding ||
								isUpdating
								? (
									<i className="label-icon"><Spinner size='sm' /></i>
								)
								: <i className="ri-save-3-line label-icon"></i>
						}
						{isEdit ? 'Editar' : 'Crear'} Dato Geodésico
					</button>
				</div>
			</div>
		</Form>
	);
};

export default GeodeticDatumForm;
